<h3>{{ 'order-details.order-product-discontinuations' | translate }}</h3>
<ng-container *ngTemplateOutlet="discontinuationsList; context:{ discontinuations: discontinuations, editMode: editMode }" />
<editable-content [offsetPosition]="editorOffsetPosition" #editor *editableData="let edit" (valueChanged)="updateDiscontinuation($event)">
	<edit-content>
		@if (edit.value) {
			<edit-plan-discontinuation [discontinuation]="edit.value" [allDiscontinuations]="discontinuations" [allowedProductPlans]="allowedProductPlans" [companyId]="companyId">
				<button small reject [ignoreValidation]="true" (click)="removeEditingDiscontinuation()"><icon type="xmark" />{{ 'order-product-discontinuations.remove' | translate }}</button>
			</edit-plan-discontinuation>
		}
	</edit-content>
</editable-content>
@if (editMode) {
	<section>
		<button small (click)="addNewDiscontinuation()" [loader]="false"><icon type="plus" />{{ 'order-product-discontinuations.add-new' | translate }}</button>
	</section>
	@if (hasMigratedInvoices) {
		<section>
			<button (click)="manuallyEditRemainingAndCounterAdjustment()" [loader]="false">{{ 'order-product-discontinuations.migrated-invoices.manually-edit-remaining-and-counter-adjustment' | translate }}</button>
		</section>
		<editable-content #editorManualValues *editableData="let edit" (valueChanged)="updateDiscontinuationsManually($event)">
			<edit-content>
				@if (!totalPlanValueGreaterThanRemainingAndAdjustment) {
					<section one-column alert>{{ 'order-product-discontinuations.remaining-amount-and-adjustment-amount-exceeds-total' | translate }}</section>
				}
				<section one-column>
					<text-group>{{ 'order-product-discontinuations.total-discontinued-plan-value' | translate: { value: totalDiscontinuationAccountingPlanValue | currency } }}</text-group>
					<custom-input
						[inputType]="inputType.Currency"
						[label]="'order-product-discontinuations.total-remaining-amount' | translate"
						[value]="totalRemainingAmount"
						(valueChange)="redistributeAmounts(edit.value, $event, 'remaining')"
						[customValidState]="totalPlanValueGreaterThanRemainingAndAdjustment" />
					<custom-input
						[inputType]="inputType.Currency"
						[label]="'order-product-discontinuations.total-adjustment-amount' | translate"
						[value]="totalAdjustmentAmount"
						(valueChange)="redistributeAmounts(edit.value, $event, 'adjustment')"
						[customValidState]="totalPlanValueGreaterThanRemainingAndAdjustment" />
				</section>
				<ng-container *ngTemplateOutlet="discontinuationsList; context:{ discontinuations: edit.value, editMode: false }" />
			</edit-content>
		</editable-content>
	}
}

<ng-template #discontinuationsList let-discontinuations="discontinuations" let-editMode="editMode">
<list-view [selectable]="false">
	<header>{{ 'order-product-discontinuations.product-name' | translate }}</header>
	<header align-right>{{ 'order-product-discontinuations.remainingAmount' | translate }}</header>
	<header align-right>{{ 'order-product-discontinuations.adjustmentAmount' | translate }}</header>
	<row *listData="let discontinuation from discontinuations" [clickable]="editMode" (action)="editMode ? edit(discontinuation, editorPlacement) : null" #editorPlacement>
		<column>{{ discontinuation.productPlan | productName }}</column>
		<column [sortValue]="discontinuation.remainingAmount" align-right>{{ discontinuation.remainingAmount | currency }}</column>
		<column [sortValue]="discontinuation.adjustmentAmount" align-right>{{ discontinuation.adjustmentAmount | currency }}</column>
	</row>
</list-view>
</ng-template>
